import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import LinkBack from '../widgets/LinkBack';
import ContactsInfo from './ContactsInfo';
import ContactsList from './ContactsList';
import ContactsMap from './ContactsMap';

import './contacts.scss';

class ContactsTemplate extends PureComponent {
  render() {
    return (
      <div className="contacts">
        {(this.props.content.meta) &&
          <Helmet>
            <title>{this.props.content.meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="contacts-content">
            <LinkBack link="/we/subnavigation/">
              мы <i>вернуться</i>
            </LinkBack>

            <h1>Контакты</h1>

            <div className="contacts-map-container">
              <ContactsInfo content={this.props.content.contacts} />

              <ContactsMap content={this.props.content.map} />
            </div>
          </div>

          <div className="contacts-panel">
            <ContactsList items={this.props.content.persons} />
          </div>
        </div>
      </div>
    );
  }
}

ContactsTemplate.propTypes = {
  content: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string
    }),
    map: PropTypes.object,
    contacts: PropTypes.object,
    persons: PropTypes.arrayOf(PropTypes.object)
  })
};

export default ContactsTemplate;



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsTemplate.js